<template>
  <v-alert 
    v-if="messageData.status === 0"
    class="reg-v-alert"
    dense
    text
    type="success"
    >
    {{ "lng_success_txt" | translate }}
  </v-alert>
  <v-alert 
    v-else
    class="reg-v-alert"
    dense
    text
    type="error"
    >
    {{ messageData.msg }}
  </v-alert>
</template>
<script>
  export default {
    data: () => ({
      timerInstance: undefined
    }),
    props: {
      messageData: {
        type: Object,
        default: () => {}
      },
      alertToggle: {
        type: Boolean,
        default: true
      }
    },
    created() {
      this.setFlashTimer();
    },
    beforeDestroy() {
      clearTimeout(this.timerInstance);
    },
    methods: {
      setFlashTimer() {
        this.timerInstance = setTimeout(() => {
          this.$emit("alertToggleUpdate");
        }, 5000);
      }
    }
  };
</script>
  
<style scoped>
  .reg-v-alert {
    /* padding: 4px 15px;
    border-color: rgba(0, 0, 0, 0.12) !important;    
    top: 0;
    border: 0;
    border-radius: 3px;
    min-width: 300px;
    font-size: 15px;
    color: #fff; */

    position: absolute !important;
    right: 50px;
    z-index: 99;
  }
  .reg-v-alert .v-btn {
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(84, 110, 122) !important;
  }
</style>
  